// node-modules
import objectFitImages from 'object-fit-images';
import svg4everybody from 'svg4everybody';
import { TweenLite, Power1 } from 'gsap/TweenMax';
import { ScrollToPlugin } from 'gsap/all';

// polyfills
import 'dom4';

// default components
import '@/components/lazy-load';
import '@/components/preloader';
import '@/components/footer';
import '@/components/buttons';
import '@/components/scrollToTop';
import '@/components/header';
import '@/components/animations';
import '@/components/modals';

// functional components
import { sayHello } from '@/scripts/utils/sayHello';
import { menuToggle } from '@/components/hamburgerMenu';
import {
  offersSlider, servicesSlider, beforeAfterSlider, productSlider,
} from '@/components/swiperSlider';
import { Form } from '@/components/Form';
import { productCard } from '@/components/productCard';
import { customInputNumber } from '@/components/customInputNumber';
import { Dropdown } from '@/components/Dropdown';
import { initGoogleMaps } from '@/components/googleMaps';
import { scrollDownInit } from '@/components/scrollDown';

// assets
import 'styles/main.scss';
import 'fonts';
// import './scripts/play-on-scroll';
import PlayOnScroll from './scripts/play-on-scroll';
// import waitIdle from './scripts/wait-idle';

// eslint-disable-next-line
const plugins = [ScrollToPlugin];

TweenLite.defaultEase = Power1.easeOut;

document.addEventListener('DOMContentLoaded', () => {
  objectFitImages();
  svg4everybody();
  sayHello();

  // init menu
  menuToggle();

  // init scroll-down button
  scrollDownInit();

  productCard();
  customInputNumber();

  // init sliders
  document.querySelectorAll('[data-role="slider-offers"]')
    .forEach(container => offersSlider(container));

  document.querySelectorAll('[data-role="slider-services"]')
    .forEach(container => servicesSlider(container));

  document.querySelectorAll('[data-role="slider-before-after"]')
    .forEach(container => beforeAfterSlider(container));

  productSlider();

  // init form
  document.querySelectorAll('[data-role="contact-form"]')
    .forEach(element => new Form(element));

  // init dropdown
  document.querySelectorAll('[data-role*="dropdown-container"]')
    .forEach(element => new Dropdown({ element }));

  // init google maps
  document.querySelectorAll('[data-role="google-maps-container"]')
    .forEach(el => initGoogleMaps(el));

  // waitIdle(50, () => {
  document.querySelectorAll('[data-play-on-scroll]').forEach((el) => {
    new PlayOnScroll(el);
  });

  document.querySelectorAll('.editable--table.editable--table__big thead th ').forEach((th) => {
    const div = document.createElement('div');
    div.classList.add('vertical');
    div.textContent = th.textContent;
    th.textContent = '';
    th.appendChild(div);
  });
});
